module.exports = "<ul class=\"phone-numbers\">\n  <li class=\"contact-info\" [class.numbered]=\"numbered\" *ngFor=\"let contactMethod of contactMethods\">\n    <contact-method \n      [contactMethod]=\"contactMethod\"\n      [numberDisplay]=\"numberDisplay\" \n      [splittedDisplay]=\"splittedDisplay\" \n      [showIcon]=\"false\"></contact-method>\n  </li>\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./ng2/shared/contact-methods/contact-methods.component.html
// module id = 1180
// module chunks = 0